'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var WorkflowSettingsController = function WorkflowSettingsController($scope, workflowSettingsConfigService, userManagementDataService, UserManagementConstants, $log, FeatureToggleService) {
  $scope.height = {
    dashboard: 0,
    marketAnalysis: 0,
    demandTransparency: 0,
    flightAnalysis: 0,
    flightAnalysisPostDeparture: 0,
    rulesAndStrategies: 0,
    fares: 0,
    calibrationAnalysis: 0
  };
  $scope.workflows = {
    dashboard: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('dashboard'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    marketAnalysis: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('marketAnalysis'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    demandTransparency: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('demandTransparency'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    flightAnalysis: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('flightAnalysis'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    flightAnalysisPostDeparture: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('flightAnalysisPostDeparture'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    rulesAndStrategies: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('rulesAndStrategies'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    fares: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('fares'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    },
    calibrationAnalysis: {
      gridOptions: {
        columnDefs: workflowSettingsConfigService.getColumnDefs('calibrationAnalysis'),
        rowData: [],
        angularCompileRows: true,
        suppressCellSelection: true,
        rowHeight: 35
      }
    }
  };
  $scope.initialize = function () {
    if ($scope.isSystemDefault) {
      $scope.setSystemSettings();
    } else {
      $scope.setUserSettings();
    }
    $scope.collapsed = {
      dashboard: true,
      marketAnalysis: false,
      demandTransparency: false,
      flightAnalysis: false,
      flightAnalysisPostDeparture: false,
      rulesAndStrategies: false,
      fares: false,
      calibrationAnalysis: false
    };
  };
  $scope.invokeCollapse = function (collapseItem) {
    switch (collapseItem) {
      case 'dashboard':
        $scope.collapsed.dashboard = !$scope.collapsed.dashboard;
        break;
      case 'marketAnalysis':
        $scope.collapsed.marketAnalysis = !$scope.collapsed.marketAnalysis;
        break;
      case 'demandTransparency':
        $scope.collapsed.demandTransparency = !$scope.collapsed.demandTransparency;
        break;
      case 'flightAnalysis':
        $scope.collapsed.flightAnalysis = !$scope.collapsed.flightAnalysis;
        break;
      case 'flightAnalysisPostDeparture':
        $scope.collapsed.flightAnalysisPostDeparture = !$scope.collapsed.flightAnalysisPostDeparture;
        break;
      case 'rulesAndStrategies':
        $scope.collapsed.rulesAndStrategies = !$scope.collapsed.rulesAndStrategies;
        break;
      case 'fares':
        $scope.collapsed.fares = !$scope.collapsed.fares;
        break;
      case 'calibrationAnalysis':
        $scope.collapsed.calibrationAnalysis = !$scope.collapsed.calibrationAnalysis;
    }
  };
  $scope.setUserSettings = function () {
    setData('dashboard', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('marketAnalysis', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('demandTransparency', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('flightAnalysis', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('flightAnalysisPostDeparture', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('rulesAndStrategies', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('fares', _.get($scope.user, 'preferences.workflowSettings', {}));
    setData('calibrationAnalysis', _.get($scope.user, 'preferences.workflowSettings', {}));
  };
  $scope.setSystemSettings = function () {
    userManagementDataService.getDefaultWorkflowSettings().then(function (systemDefaults) {
      setData('dashboard', systemDefaults);
      setData('marketAnalysis', systemDefaults);
      setData('demandTransparency', systemDefaults);
      setData('flightAnalysis', systemDefaults);
      setData('flightAnalysisPostDeparture', systemDefaults);
      setData('rulesAndStrategies', systemDefaults);
      setData('fares', systemDefaults);
      setData('calibrationAnalysis', systemDefaults);
    });
  };
  function close() {
    if ($scope.isOwnProfile) {
      $scope.$emit('user-profile:change-screen', UserManagementConstants.USER_PROFILE_SCREENS.USER_PROFILE);
    } else if (!$scope.isSystemDefault) {
      $scope.$emit('user-management-manage-users:change-screen', UserManagementConstants.MANAGE_USERS_SCREENS.USER_PROFILE);
    }
  }
  $scope.isWorkflowEnable = function (workflow) {
    var featureDependant = {
      fares: 'FIM'
    };
    if (featureDependant[workflow] === undefined) {
      return true;
    }
    return FeatureToggleService.isEnabled(featureDependant[workflow]);
  };
  function setData(workflow, data) {
    if (!$scope.isWorkflowEnable(workflow)) {
      return false;
    }
    var gridOptions = _.get($scope.workflows, [workflow, 'gridOptions']);
    if ($scope.workflows && $scope.workflows[workflow]) {
      gridOptions.api.setRows(workflowSettingsConfigService.getWorkflowSettings(workflow, data[workflow]));
      gridOptions.api.onNewRows();
      $scope.calculateGridHeight(gridOptions.rowData.length, workflow);
      gridOptions.api.sizeColumnsToFit();
    }
  }
  function populateWorkflowSettings(defaultWorkflowSettings) {
    _.forOwn(defaultWorkflowSettings, function (defaultSettings, workflow) {
      var workflowData = _.get($scope.workflows, [workflow, 'gridOptions', 'rowData'], []);
      _.forEach(defaultSettings, function (setting) {
        var currentSetting = _.find(workflowData, {
          title: setting.name
        });
        if (currentSetting) {
          currentSetting.value = {
            id: setting.value
          };
        }
      });
    });
  }
  $scope.calculateGridHeight = function (rows, workflow) {
    $scope.height[workflow] = rows * 35 + 26;
  };
  $scope.save = function () {
    var marketDefaultSearchDays = 0;
    var flightDefaultSearchDays = 0;
    var topFlowMarketThreshold = 0;
    var workflowSetting = {};
    _.forOwn($scope.workflows, function (workflowOptions, index) {
      workflowSetting[index] = _.transform(workflowOptions.gridOptions.rowData, function (result, data) {
        result.push({
          name: data.title,
          value: _.get(data, 'value.id')
        });
      }, []);
    });
    marketDefaultSearchDays = _.get(_.find(workflowSetting.marketAnalysis, ['name', 'defaultSearchDays']), 'value');
    flightDefaultSearchDays = _.get(_.find(workflowSetting.flightAnalysis, ['name', 'defaultSearchDays']), 'value');
    topFlowMarketThreshold = _.get(_.find(workflowSetting.flightAnalysis, ['name', 'topFlowMarketThreshold']), 'value');
    if (marketDefaultSearchDays === undefined || marketDefaultSearchDays > 365 || marketDefaultSearchDays < 0) {
      $log.error('WorkflowSettingsController: save - Error: Market Analysis search days must be within 0 to 365 days');
      toastr.error('Error: Market Analysis search days must be within 0 to 365 days.');
      return;
    }
    if (flightDefaultSearchDays === undefined || flightDefaultSearchDays > 365 || flightDefaultSearchDays < 0) {
      $log.error('WorkflowSettingsController: save - Error: Flight Analysis search days must be within 0 to 365 days');
      toastr.error('Error: Flight Analysis search days must be within 0 to 365 days.');
      return;
    }
    if (FeatureToggleService.isEnabled('FLOW_MIX') && (topFlowMarketThreshold > 365 || topFlowMarketThreshold < 0 || topFlowMarketThreshold === undefined)) {
      $log.error('WorkflowSettingsController: save - Error: Top Flow Market Metric must be within 0 to 365 days');
      toastr.error('Error: Top Flow Market Metric must be within 0 to 365 days.');
      return;
    }
    if (!$scope.isSystemDefault) {
      _.forOwn(workflowSetting, function (settings, workflow) {
        var userWorkflowSettings = _.get($scope.user, ['preferences', 'workflowSettings', workflow], null);
        if (userWorkflowSettings) {
          var newUserSettings = [];
          userWorkflowSettings = _.uniqBy(userWorkflowSettings, 'name');
          _.transform(userWorkflowSettings, function (result, workflowSetting) {
            var setting = _.find(settings, {
              name: workflowSetting.name
            });
            if (setting) {
              workflowSetting.value = setting.value;
            }
            result.push(workflowSetting);
            return result;
          }, newUserSettings);
          var newWorkflowSettings = _.differenceWith(settings, newUserSettings, _.isEqual);
          var allUserSettings = _.concat(newUserSettings, newWorkflowSettings);
          _.set($scope.user, ['preferences', 'workflowSettings', workflow], allUserSettings);
        } else {
          _.set($scope.user, ['preferences', 'workflowSettings', workflow], settings);
        }
      });

      //_.set($scope.user, 'preferences.workflowSettings', userWorkflowSettings);
      userManagementDataService.updateWorkflowSettings($scope.user, $scope.isOwnProfile).then(function () {
        toastr.success('User workflow settings saved');
        close();
      })["catch"](function () {
        $log.error('WorkflowSettingsController: userManagementDataService.updateWorkflowSettings - Error: User workflow settings not saved');
        toastr.error('Error: User workflow settings not saved');
      });
    } else {
      userManagementDataService.updateSystemDefaultWorkflowSettings(workflowSetting).then(function () {
        toastr.success('System default workflow settings saved');
        close();
      })["catch"](function () {
        $log.error('WorkflowSettingsController: userManagementDataService.updateSystemDefaultWorkflowSettings - Error: System default workflow settings not saved');
        toastr.error('Error: System default workflow settings not saved');
      });
    }
  };
  $scope.cancel = function () {
    close();
  };
  $scope.resetToDefault = function () {
    if (!$scope.isSystemDefault) {
      userManagementDataService.getDefaultWorkflowSettings().then(function (defaultWorkflowSettings) {
        populateWorkflowSettings(defaultWorkflowSettings);
      });
    } else {
      //Delete any modified system settings
      userManagementDataService.deleteSystemDefaultWorkflowSettings().then(setTimeout(function () {
        userManagementDataService.getDefaultWorkflowSettings().then(function (defaultWorkflowSettings) {
          populateWorkflowSettings(defaultWorkflowSettings);
        });
      }, 100));
    }
  };
};
WorkflowSettingsController.$inject = ['$scope', 'WorkflowSettingsConfigService', 'UserManagementDataService', 'UserManagementConstants', '$log', 'FeatureToggleService'];
module.exports = WorkflowSettingsController;